import type { StudyType } from "@/lib/study-type";
import { DEFAULT_MAX_RESPONDENTS } from "@digital-twins/shared-types";

export type { StudyType } from "@/lib/study-type";
export {
  getStudyTypeCategoryLabel,
  humanizeStudyTypeId,
} from "@/lib/study-type";

export const STUDY_CREATION_TYPE_ID = "custom-questionnaire";

export const STUDY_CREATION_TYPE = {
  id: STUDY_CREATION_TYPE_ID,
  title: "Custom Questionnaire",
  description:
    "Start from a research objective and let AI draft a full custom questionnaire.",
  category: "Custom",
  respondentLimits: {
    min: 30,
    max: DEFAULT_MAX_RESPONDENTS,
  },
  metadata: {
    subjectType: "custom_questionnaire",
    discovery: {
      categoryLabel: "Custom",
      wizardOrder: 1,
    },
  },
} satisfies StudyType;

